import axios from 'axios';

export type ManufactureParams = {
  name: string;
  printName: string;
  englishName: string;
};

export const getManufacturers = (params: {
  category_id?: number;
  page?: number;
  per_page?: number;
  text?: string;
}) => axios.get('/api/shop/manufacturers', { params });

export const getSearchManufacturers = ({
  page = 1,
  per_page = 10,
  search,
  manufacturer_ids,
}: {
  page?: number;
  per_page?: number;
  search: string;
  manufacturer_ids?: string;
}) =>
  axios.get('/api/shop/products/all', {
    params: {
      page,
      per_page,
      text: search.trim() ? search : undefined,
      manufacturer_ids,
      objects_type: 'manufacturers',
    },
  });

export const getManufacturer = (id: number) => axios.get(`/api/shop/manufacturer/${id}`);

export const createManufacture = (params: ManufactureParams) =>
  axios.post('/api/shop/manufacturer', params);

export const editManufacture = (id: number, params: ManufactureParams) =>
  axios.put(`/api/shop/manufacturer/${id}`, params);

export const deleteManufacturer = (id: number) => axios.delete(`/api/shop/manufacturer/${id}`);
